// extracted by mini-css-extract-plugin
module.exports = {"TypingIndicator":"_3qJmer93p8G8xdZmEiLhAe","TypingIndicatorIcon":"_4_5JmeTlYlKy84lwF1hr1","TypingIndicatorContent":"VIRD4FA7L4Z3R_FWa_gPP"};